
/**
 * \@experimental Animation support is experimental.
 * @abstract
 */
export abstract class AnimationStyleNormalizer {
/**
 * @abstract
 * @param {?} propertyName
 * @param {?} errors
 * @return {?}
 */
normalizePropertyName(propertyName: string, errors: string[]) {}
/**
 * @abstract
 * @param {?} userProvidedProperty
 * @param {?} normalizedProperty
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
normalizeStyleValue(
      userProvidedProperty: string, normalizedProperty: string, value: string|number,
      errors: string[]) {}
}
/**
 * \@experimental Animation support is experimental.
 */
export class NoopAnimationStyleNormalizer {
/**
 * @param {?} propertyName
 * @param {?} errors
 * @return {?}
 */
normalizePropertyName(propertyName: string, errors: string[]): string { return propertyName; }
/**
 * @param {?} userProvidedProperty
 * @param {?} normalizedProperty
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
normalizeStyleValue(
      userProvidedProperty: string, normalizedProperty: string, value: string|number,
      errors: string[]): string {
    return /** @type {?} */(( <any>value));
  }
}
